/* istanbul ignore next */
const operator = {
    scrollToTop: () => { }
};
/* istanbul ignore next */
const getOperatorFunctions = (operator) => {
    Object.keys(operator).forEach((func) => {
        operator[func] = window && window["whl"] && typeof window["whl"][func] === "function"
            ? window["whl"][func]
            : () => { throw new Error(`${func} is missing from whl object`); };
    });
    return operator;
};
/* istanbul ignore next */
export const seamlessApi = Object.defineProperties({}, {
    operator: {
        enumerable: false,
        configurable: false,
        get: () => getOperatorFunctions(operator),
        set: (x) => { throw new Error(`Readonly property "operator" cannot be set`); }
    }
});
//# sourceMappingURL=SeamlessApi.js.map